import React from 'react';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    emoji: '🎯',
    title: 'NIVELÓMETRO 360',
    desc: 'El sistema de semáforo para evaluar y ubicar a cada alumna en su nivel real. Sin errores. Sin improvisación.',
    cover: 'bg-blue-700',
    spine: 'bg-blue-900'
  }, {
    emoji: '📅',
    title: 'FÍSICO EXPRESS',
    desc: 'Planes de preparación física por sección y edad. Circuitos listos para usar sin equipamiento especial.',
    cover: 'bg-emerald-700',
    spine: 'bg-emerald-900'
  }, {
    emoji: '🍎',
    title: 'NUTRICIÓN Y RENDIMIENTO',
    desc: 'Guía de alimentación práctica para gimnastas de todas las edades. Scripts para hablar con padres.',
    cover: 'bg-rose-700',
    spine: 'bg-rose-900'
  }, {
    emoji: '🎮',
    title: 'KIT DE SUPERVIVENCIA',
    desc: '30 juegos técnicos para clases infantiles. Con objetivo gimnástico real y variantes para no repetir nunca lo mismo.',
    cover: 'bg-violet-700',
    spine: 'bg-violet-900'
  }, {
    emoji: '🚨',
    title: 'CLASES DE EMERGENCIA',
    desc: '10 clases completas listas para usar cuando no tuviste tiempo de planificar. El fin del domingo a la noche con ansiedad.',
    cover: 'bg-amber-600',
    spine: 'bg-amber-800'
  }, {
    emoji: '📋',
    title: 'PACK DE ORGANIZACIÓN SEMANAL',
    desc: '8 planillas visuales para organizar tu semana en 20 minutos. Checklist, tracker de progreso y comunicación con padres incluidos.',
    cover: 'bg-teal-700',
    spine: 'bg-teal-900'
  }];
  return <section className="py-20 bg-white" data-id="element-16">
      <div className="max-w-6xl mx-auto px-4" data-id="element-17">
        <div className="text-center mb-12" data-id="element-18">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-red-100 mb-6" data-id="element-19">
            <Gift className="w-8 h-8 text-red-500" data-id="element-20" />
          </div>
          <h2 className="text-4xl font-extrabold text-gray-900 mb-4" data-id="element-21">
            + 6 Regalos Estratégicos
          </h2>
          <p className="text-xl text-gray-600 mb-6" data-id="element-22">
            Incluidos sin costo extra · Valor real del pack
          </p>
          <div className="inline-block bg-red-500 text-white font-bold px-6 py-2 rounded-full animate-pulse" data-id="element-23">
            🎁 GRATIS POR EL DÍA DE HOY
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-24">
          {bonuses.map((bonus, i) => <div key={i} className="bg-white rounded-2xl p-6 border border-gray-100 shadow-sm hover:shadow-lg transition-shadow flex flex-col items-center text-center" data-id="element-25">
              {/* Book cover mockup */}
              <div className="mb-6 relative group" data-id="element-26">
                <div className={`relative w-40 h-52 rounded-lg ${bonus.cover} shadow-xl overflow-hidden transform group-hover:-translate-y-1 transition-transform`} data-id="element-27">
                  {/* Spine */}
                  <div className={`absolute left-0 top-0 h-full w-3 ${bonus.spine}`} data-id="element-28"></div>
                  <div className="absolute inset-0 pl-3 flex flex-col justify-between p-4 text-white" data-id="element-29">
                    <span className="text-3xl" data-id="element-30">{bonus.emoji}</span>
                    <div data-id="element-31">
                      <span className="text-lg font-bold block leading-tight" data-id="element-32">
                        Bonus {i + 1}
                      </span>
                    </div>
                    <div data-id="element-33">
                      <div className="w-full h-px bg-white/30 mb-3" data-id="element-34"></div>
                      <span className="text-[10px] font-semibold tracking-widest text-white/80" data-id="element-35">
                        GIMNASIA 360™
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* GRATIS pill */}
              <span className="inline-block bg-emerald-100 text-emerald-700 text-xs font-bold px-4 py-1.5 rounded-full mb-4" data-id="element-36">
                GRATIS
              </span>

              <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center justify-center gap-2" data-id="element-37">
                <span className="text-2xl" data-id="element-38">{bonus.emoji}</span> Bonus {i + 1} —{' '}
                {bonus.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-39">
                {bonus.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}